<template>
  <div class="party-entry-list">
    <div class="topic-list party-topic-list">
      <div
        v-for="item in front.partyListItems"
        :key="item.entryId || item.title"
        class="party-entry-row"
      >
        <button type="button" class="party-entry-open" @click="front.openPartyEntry(item)">
          <strong>{{ item.title }}</strong>
          <span>{{ item.summary || item.date || '暂无摘要' }}</span>
        </button>
        <div v-if="front.entryAttachments(item).length" class="party-entry-files">
          <button
            v-for="(file, index) in front.entryAttachments(item)"
            :key="file.id || file.url || index"
            type="button"
            class="party-file-link"
            @click="front.downloadEntryAttachment(item, file)"
          >
            {{ front.attachmentLabel(file, index, front.entryAttachments(item).length) }}
          </button>
        </div>
      </div>
      <p v-if="!front.partyListItems.length" class="muted-copy">暂无已发布内容，请在管理后台维护</p>
    </div>
    <FrontPagination
      :page-num="front.partyListPageNum"
      :page-size="front.partyListPageSize"
      :total="front.partyListTotal"
      @change="page => front.changePartyListPage(page)"
    />
  </div>
</template>

<script>
import FrontPagination from '../common/FrontPagination.vue'

export default {
  name: 'PartyEntryList',
  components: { FrontPagination },
  inject: ['front']
}
</script>
